import { Menu, Search, ShoppingBag, User } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { Currency } from "../lib/currency";
import { t } from "../lib/i18n";
import CurrencySwitcher from "./CurrencySwitcher";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header({ currency, onCurrency, onCart }: { currency: Currency; onCurrency: (v: Currency) => void; onCart: () => void }) {
  const { lang = "en" } = useParams();
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/92 backdrop-blur">
      <div className="container-page flex h-16 items-center gap-4">
        <Link to={`/${lang}`} className="flex items-center gap-2 font-black"><img src="/logo.svg" className="h-9" /></Link>
        <nav className="hidden flex-1 items-center gap-6 text-sm font-semibold md:flex">
          <Link to={`/${lang}/products`}>{t(lang, "shop")}</Link>
          <Link to={`/${lang}/category/featured`}>Categories</Link>
          <Link to={`/${lang}/blog`}>Journal</Link>
          <Link to={`/${lang}/contact`}>Support</Link>
        </nav>
        <div className="hidden flex-1 items-center rounded-md bg-slate-100 px-3 md:flex"><Search size={18} /><input className="w-full bg-transparent px-2 py-2 outline-none" placeholder={t(lang, "search")} /></div>
        <LanguageSwitcher />
        <CurrencySwitcher value={currency} onChange={onCurrency} />
        <Link className="hidden rounded-md p-2 hover:bg-slate-100 md:block" to={`/${lang}/account`}><User size={20} /></Link>
        <button className="rounded-md p-2 hover:bg-slate-100" onClick={onCart}><ShoppingBag size={20} /></button>
        <button className="rounded-md p-2 md:hidden"><Menu size={20} /></button>
      </div>
    </header>
  );
}
